/* eslint-disable import/no-anonymous-default-export */
// just because threejs is so inflexible, we will make parametrized versions of tonemapping here
// this allows us to circumvent the hardcoded tonemapping restriction found in webglprogram, see here:
// https://github.com/mrdoob/three.js/blob/dev/src/renderers/webgl/WebGLProgram.js#L644
export default /* glsl */`
#ifndef saturate
// <common> may have defined saturate() already
#define saturate(a) clamp( a, 0.0, 1.0 )
#endif

#define TONEMAP_NONE 0
#define TONEMAP_LINEAR 1
#define TONEMAP_REINHARD 2
#define TONEMAP_CINEON 3
#define TONEMAP_ACES 4
#define TONEMAP_CUSTOM 5

struct TonemappingData {
	int type;
	float exposure;
};

uniform TonemappingData tonemappingData;

// exposure only
vec3 LinearToneMapping( vec3 color, float exposure ) {

	return exposure * color;

}

// source: https://www.cs.utah.edu/~reinhard/cdrom/
vec3 ReinhardToneMapping( vec3 color, float exposure  ) {

	color *= exposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );

}

// source: http://filmicworlds.com/blog/filmic-tonemapping-operators/
vec3 OptimizedCineonToneMapping( vec3 color, float exposure  ) {

	// optimized filmic operator by Jim Hejl and Richard Burgess-Dawson
	color *= exposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );

}

// this implementation of ACES is modified to accommodate a brighter viewing environment.
// the scale factor of 1/0.6 is subjective. see discussion in #19621.

vec3 ACESFilmicToneMapping( vec3 color, float exposure  ) {

	// sRGB => XYZ => D65_2_D60 => AP1 => RRT_SAT
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ), // transposed from source
		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);

	// ODT_SAT => XYZ => D60_2_D65 => sRGB
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ), // transposed from source
		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);

	color *= exposure / 0.6;

	color = ACESInputMat * color;

	// Apply RRT and ODT
	color = RRTAndODTFit( color );

	color = ACESOutputMat * color;

	// Clamp to [0, 1]
	return saturate( color );

}
`;